import React, { createContext, ReactNode, useState, useContext } from 'react';
import type { ManualGroup } from 'views/App/Portal/Policy/IssuedManuals/_data_sources/useIssuedManualGroups';

interface AssignmentContextValue {
  selectedGroups: ManualGroup[];
  setSelectedGroups: React.Dispatch<React.SetStateAction<ManualGroup[]>>;
  notificationSettings: {
    email: boolean;
    push: boolean;
    consolidate: string;
    overdue: boolean;
    manual: boolean;
  };
  setNotificationSettings: React.Dispatch<
    React.SetStateAction<{
      email: boolean;
      push: boolean;
      consolidate: string;
      overdue: boolean;
      manual: boolean;
    }>
  >;
  schedule: {
    dueDate: string;
  };
  setSchedule: React.Dispatch<React.SetStateAction<{ dueDate: string }>>;
}

export const AssignmentContext = createContext<AssignmentContextValue | undefined>(undefined);

export const AssignmentProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedGroups, setSelectedGroups] = useState<ManualGroup[]>([]);
  const [notificationSettings, setNotificationSettings] = useState({
    email: true,
    push: false,
    consolidate: 'daily',
    overdue: true,
    manual: false,
  });
  const [schedule, setSchedule] = useState({ dueDate: new Date().toISOString() });
  return (
    <AssignmentContext.Provider
      value={{
        selectedGroups,
        setSelectedGroups,
        notificationSettings,
        setNotificationSettings,
        schedule,
        setSchedule,
      }}
    >
      {children}
    </AssignmentContext.Provider>
  );
};

export const useAssignmentContext = () => {
  const ctx = useContext(AssignmentContext);
  if (!ctx) throw new Error('useAssignmentContext must be used within AssignmentProvider');
  return ctx;
};
